import React, {useEffect, useState, useContext} from "react";
import {toast} from "react-toastify";
import {Avatar, Box, Button, CircularProgress, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";
import {removeFile, uploadFile} from "../../utils/functions";
import {auth} from "../../config/firebase";
import {Context as AppContext} from "../../context/AppContext";
import {Card} from "./card";
export const ProfileImage = () => {
  const {state: {currentUser}, updateUserData} = useContext(AppContext);
  const [image, setImage] = useState(auth?.currentUser?.photoURL);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setImage(currentUser?.photoURL || null);
    }
  }, [currentUser])

  const chooseProfile = async (event) => {
    try {
      console.log("File selection triggered");
      if (!event.target.files || event.target.files.length === 0) {
        console.log("No file selected");
        return;
      }
      
      setLoading(true);
      const fileUpload = event.target.files[0];
      console.log("Selected file:", fileUpload);
      
      // Check file size
      if (fileUpload.size > 700 * 1024) {
        toast.error("File size exceeds 700KB limit");
        setLoading(false);
        return;
      }
      
      const image = await uploadFile(fileUpload, `users/${auth?.currentUser?.uid}/${fileUpload?.name}`);
      console.log("Uploaded image URL:", image);
      
      // Only update the photoURL property without affecting other state
      await updateUserData({photoURL: image}, true);
      setImage(image);
      toast.success("Image updated successfully");
    } catch (error) {
      console.log("Error in chooseProfile:", error);
      toast.error(error?.message || "Failed to update image");
    } finally {
      setLoading(false);
    }
  }

  const removeImage = async (event) => {
    try {
      setLoading(true);
      if (image) {
        await removeFile(image);
      }
      // Only update the photoURL property without affecting other state
      await updateUserData({photoURL: null}, true);
      setImage(null);
      toast.success("Profile image deleted");
    } catch (error) {
      console.log(error);
      toast.error(error?.message || "Failed to delete image");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Card sx={{p: 2, display: "flex", flexDirection: "column", justifyContent: "center", gap: 2}}>
      <label htmlFor={'choose-img'} style={{textAlign: "center"}}>
        <Avatar
          sx={{width: 150, height: 150, cursor: "pointer", fontSize: 100, color: "#FFF", mx: "auto"}}
          // onClick={chooseProfile}
          src={loading ? null : image}
        >
          {loading ? <CircularProgress size={50} /> :
            !image && currentUser?.displayName?.slice(0, 1)?.toUpperCase() || currentUser?.email?.slice(0, 1)?.toUpperCase()
          }
        </Avatar>
        <input type={"file"} id={"choose-img"}
               onChange={chooseProfile}
               onBlur={e => {
                 e.target.value = "";
               }}
               accept={"image/png, image/gif, image/jpg, image/jpeg"} hidden maxLength={700}/>
      </label>

      <Box sx={{display: 'block'}}>
        <Button
          component="label"
          color={"secondary"}
          variant={"contained"}
          fullWidth disabled={loading}
          sx={{borderRadius: 5, textTransform: "capitalize", boxShadow: 0}}
        >
          Choose Image
          <input type={"file"}
                 onChange={chooseProfile}
                 onBlur={e => {
                   e.target.value = "";
                 }}
                 accept={"image/png, image/gif, image/jpg, image/jpeg"} hidden maxLength={700}/>
        </Button>
        <Button
          color={"secondary"}
          variant={"outlined"}
          fullWidth
          disabled={!image || loading}
          onClick={removeImage}
          sx={{borderRadius: 5, textTransform: "capitalize", mt: 1, display: 'block'}}
        >
          Remove
        </Button>
        <Typography variant={"subtitle2"} color={grey[500]} sx={{mt: 1, fontSize: 12}}>
          .jpg, .gif, or .png. Max file size 700K.
        </Typography>
      </Box>
    </Card>
  )
}